import React from "react";

const apiCall = async (method, endpoint, params, body, controller) => {

  const options = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      'Content-Encoding': 'gzip',
      accept: 'application/json',
    },
    params: params,
    body: undefined
  }

  if (controller) {
    options.signal = controller.signal;
  }

  if (body) {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(
    endpoint,
    options
  );
  const data = await response.json();
  return data;

}

export default apiCall;
